
import $ from 'jquery';

class VignetteZoom {
  constructor() {}

  /**
   * Initlizes
   */
  init() {
    var self = this;
    console.log('VignetteZoom :: init()');

    $('.vignette-container i.mdi-arrow-expand').click(function(e) {
      console.log('expand clicked');
      var target = $(e.target).closest('.vignette-container');
      target.addClass('full-screen-vignette');
      e.stopPropagation();
    });

    $('.vignette-container i.mdi-close').click(function(e) {
      console.log('close clicked');
      var target = $(e.target).closest('.vignette-container');
      target.removeClass('full-screen-vignette');
      e.stopPropagation();
    });

    $('.vignette-container').click(function(e) {
      console.log('vignette clicked');
      var target = $(e.target).parent('.vignette-container');

      target.toggleClass('full-screen-vignette');
    });
  }
}

var vignetteZoom = new VignetteZoom();
vignetteZoom.init();
